// Site-wide settings. Change them here rather than in the pages.

// Backend addresses. To point at a local backend, set these in frontend/.env,
// e.g. REACT_APP_API_URL=http://localhost:10000, then restart `npm start`.
export const API_URL =
  process.env.REACT_APP_API_URL || "https://car-project-backend-auto.onrender.com";
export const MANUAL_API_URL =
  process.env.REACT_APP_MANUAL_API_URL || "https://car-project-backend-manual.onrender.com";
export const AUTH_API_URL = process.env.REACT_APP_AUTH_API_URL || "http://localhost:10000";

// Pricing. While FREE_PROMO is true, every price shows as "£2.99" crossed out
// followed by "Free", and the offer banner appears at the top of every page.
export const REPORT_PRICE = "£2.99";
export const FREE_PROMO = true;

// The header and footer logo. This is the favicon artwork at 512px, so it stays sharp.
export const LOGO_SRC = "/logo192.png";

export const CONTACT_EMAIL = "carsensesolutions@gmail.com";
export const LINKEDIN_URL = "https://www.linkedin.com/in/adithyavirakthi";
